
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.471.117a1.268 1.268 0 011.267 1.267v6.582a.422.422 0 01-.845 0V1.384a.422.422 0 00-.422-.422H2.026a.423.423 0 00-.422.422v10.805a.422.422 0 00.422.422h4.223a.422.422 0 110 .845H2.026A1.268 1.268 0 01.759 12.19V1.384A1.268 1.268 0 012.026.117z"}}),_c('path',{attrs:{"d":"M9.04 13.761a.515.515 0 00.762-.041l3.5-4.289a.516.516 0 10-.8-.652L9.37 12.633 8.183 11.46a.516.516 0 00-.725.733l1.586 1.568M2.768 3.688a.437.437 0 01.437-.437h2.624a.437.437 0 010 .874H3.206a.436.436 0 01-.437-.436zM8.016 5.438a.437.437 0 01-.437.437H3.205a.437.437 0 010-.874h4.374a.437.437 0 01.437.438zM8.003 7.187a.437.437 0 01-.437.437H3.205a.437.437 0 010-.874h4.36a.437.437 0 01.438.437z"}})])
          )
        }
      }
    